(function($) {
    $('.boat-single-nav').on('click', function(event) {
        event.preventDefault();
        $('.boat-single-nav--active').removeClass('boat-single-nav--active');
        $(this).addClass('boat-single-nav--active');
        $('.boat-tab').removeClass('boat-tab--active');
        $('#' + $(this).attr('data-tab')).addClass('boat-tab--active').find('.gallery-slider').slick('setPosition');
        $('#' + $(this).attr('data-tab')).find('iframe').each(function() {
            $(this).attr('src', $(this).attr('src'));
        })
    });

    $('.boat-tab__tab').on('click', function() {
        $(this).parent().toggleClass('boat-tab--active').find('.gallery-slider').slick('setPosition');
        $(this).parent().find('iframe').each(function() {
            $(this).attr('src', $(this).attr('src'));
        })
    })
})(jQuery);